
export default (apiMethods, endpoints) => ({
    getProducts: () => {
        return apiMethods.get(endpoints.GET_PRODUCTS_ENDPOINT);
    },
    getProduct: (productId) => {
        return apiMethods.get(endpoints.GET_PRODUCT_ENDPOINT + '/' + productId);
    },
    addProductData: (productData) => {
        let formdata = productToFormData(productData);

        formdata.append('constant', 'FURNITURE');
        
        return apiMethods.post(endpoints.ADD_PRODUCT_DATA_ENDPOINT, formdata, {
            'Content-Type': 'multipart/form-data'
        });
    },

    updateProductFields: (productData, productId) => {
        let formdata = productToFormData(productData);
        return apiMethods.put(endpoints.UPDATE_PRODUCT_ENDPOINT + '/' + productId, formdata, {
            'Content-Type': 'multipart/form-data'
        });
    },

    deleteProduct: (productId) => {
        return apiMethods.delete(endpoints.DELETE_PRODUCT_ENDPOINT + '/' + productId);
    },
    publishProduct: (productId) => {
        return apiMethods.post(endpoints.PUBLISH_PRODUCT_ENDPOINT + '/' + productId)
    },
    unPublishProduct: (productId) => {
        return apiMethods.post(endpoints.UNPUBLISH_PRODUCT_ENDPOINT + '/' + productId)
    },
    updateProductTextures: (newTextures, existingTextures, deleteTextureIds, constant, productId) => {
        const formdata = new FormData();
        newTextures.forEach((texture) => {
            formdata.append('texture_gallery', texture.textureFile)
            formdata.append('names[]', texture.textureName)
        })
        existingTextures.forEach((texture, index) => {
            formdata.append(`existing_textures[${index}][name]`, texture.textureName ? texture.textureName : '')
            formdata.append(`existing_textures[${index}][id]`, texture.textureId)
        })
        deleteTextureIds.forEach(textureId => {
            formdata.append('delete_textures[]', textureId);
        })
        formdata.append('constant', constant);

        return apiMethods.put(endpoints.UPDATE_PRODUCT_TEXTURES_ENDPOINT + '/' + productId, formdata, {
            'Content-Type': 'multipart/form-data'
        });
    },

    toggleAllowDownload: (productId) => {
        return apiMethods.get(endpoints.TOGGLE_ALLOW_DOWNLOAD_ENDPOINT + '/' + productId)
    },
    toggleAllowFavourite: (productId) => {
        return apiMethods.get(endpoints.TOGGLE_ALLOW_FAVOURITE_ENDPOINT + '/' + productId)
    },
    toggleFeatured: (productId) => {
        return apiMethods.get(endpoints.TOGGLE_FEATURED_ENDPOINT + '/' + productId)
    },
    toggleAllowShare: (productId) => {
        return apiMethods.get(endpoints.TOGGLE_ALLOW_SHARE_ENDPOINT + '/' + productId)
    },
})

function productToFormData(productData) {
    let formdata = new FormData();
    Object.keys(productData).forEach(key => {
        switch (key) {
            case 'tag':
                formdata.append(key, JSON.stringify(productData[key]));
                break;
            case 'modelFiles':
                const modelFiles = productData[key]
                if (modelFiles) {
                    modelFiles.forEach(modelFile => {
                        let {file, error, ...fileMeta} = modelFile;
                        if (fileMeta) formdata.append('modelFilesMeta', JSON.stringify(fileMeta))
                        if (file) formdata.append('modelFiles', file)
                    })
                }
                break;
            default:
                formdata.append(key, productData[key]);
                break;
        }
    });
    return formdata;
}



// WEBPACK FOOTER //
// ./src/lib/api-product.js